module.exports = __webpack_public_path__ + "img/s8-qa1.bcf310cf.png";